import { render, staticRenderFns } from "./onboarding-list.vue?vue&type=template&id=40c82e7a&scoped=true"
import script from "./onboarding-list.vue?vue&type=script&lang=js"
export * from "./onboarding-list.vue?vue&type=script&lang=js"
import style0 from "./onboarding-list.vue?vue&type=style&index=0&id=40c82e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c82e7a",
  null
  
)

export default component.exports